// contexts/RolesContext.js
import React, { createContext, useContext } from "react";

// Definisci il contesto dei ruoli
const RolesContext = createContext();

// Funzione per il provider dei ruoli
export const RolesProvider = (props) => {
  // Oggetto contenente solo i ruoli
  const roles = {
    admin: {
      routesAllowed: ["*"],
    },
    machinesViewer: {
      routesAllowed: ["machines"],
    },
    productsViewer: {
      routesAllowed: ["product"],
    },
    meViewer: {
      routesAllowed: ["machines", "mappings"],
    },
    contentViewer: {
      routesAllowed: ["content"],
    },
    productsContentViewer: {
      routesAllowed: ["product", "content"],
    },
  };

  // Restituisci il provider del contesto dei ruoli con i valori
  return (
    <RolesContext.Provider value={roles}>
      {props.children}
    </RolesContext.Provider>
  );
};

// Hook personalizzato per usare il contesto dei ruoli
export const useRoles = () => {
  return useContext(RolesContext);
};

// Mappa delle sezioni ai ruoli
export const sectionsToRole = {
  ALL: "admin",
  ME: "meViewer",
  PRODUCT: "productsViewer",
  CONTENT: "contentViewer",
  PRODUCT_CONTENT: "productsContentViewer",
};
